module.exports = __webpack_public_path__ + "img/freccia_su_dx.ce983e04.svg";